import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { CreateCurrencyMaster, CurrencyMaster, UpdateCurrencyMaster } from '@dcc-erp/shared';

import { api, apiJson } from '../api';

const key = () => ['currencies'] as const;

export function useCurrencies(activeOnly = true) {
  return useQuery({
    queryKey: [...key(), { activeOnly }],
    queryFn: () => api<CurrencyMaster[]>(`/currencies?activeOnly=${activeOnly}`),
  });
}

export function useCurrency(code: string | undefined) {
  return useQuery({
    queryKey: ['currencies', code],
    queryFn: () => api<CurrencyMaster>(`/currencies/${code}`),
    enabled: !!code,
  });
}

export function useCreateCurrency() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCurrencyMaster) =>
      apiJson<CreateCurrencyMaster, CurrencyMaster>('POST', `/currencies`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: key() }),
  });
}

export function useUpdateCurrency() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ code, data }: { code: string; data: UpdateCurrencyMaster }) =>
      apiJson<UpdateCurrencyMaster, CurrencyMaster>('PATCH', `/currencies/${code}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: key() }),
  });
}
